const callbackName = 'onRecatpchaLoad';

let isLoaded = false;
const onloadQueue = [];

window[callbackName] = () => {
    isLoaded = true;
    onloadQueue.forEach((callback) => callback(window.grecaptcha));
};

export function onReady(callback) {
    if (isLoaded) {
        callback(window.grecaptcha);
    } else {
        onloadQueue.push(callback);
    }
}

function insertScript() {
    const script = document.createElement('script');
    script.async = true;
    script.defer = true;
    script.src = `https://www.google.com/recaptcha/api.js?onload=${callbackName}&render=explicit`;
    const s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(script, s);
}

insertScript();

const recapchaLoader = {
    onReady
};

export default recapchaLoader;
